module.exports = (__parcel__import__("7tACk")).then(() => parcelRequire('fyWP3'));